export const MatchKitPreview = ({ kit, lang }) => {
  if (!kit) return null;

  const title = lang === 'fr' ? kit.titleFr : kit.title;
  const description = lang === 'fr' ? kit.descriptionFr : kit.description;

  return (
    <section
      className="mx-6 md:mx-10 mt-12 border-y border-[#C9C6BE] py-8 md:py-10"
      aria-labelledby="match-kit-heading"
      data-testid="team-match-kit"
    >
      <div className="max-w-6xl mx-auto grid md:grid-cols-[1fr_1.5fr] gap-6 md:gap-12 items-center">
        <div className="min-w-0">
          <p className="text-xs font-semibold text-[#2E9BD6] mb-3" data-testid="team-match-kit-models">
            CROATIA M098 · VISTA P8000 · UEFA C002
          </p>
          <h2 id="match-kit-heading" className="font-bebas text-4xl md:text-5xl leading-none" data-testid="team-match-kit-title">
            {title}
          </h2>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-[#4A4F5E] max-w-md" data-testid="team-match-kit-description">
            {description}
          </p>
        </div>
        <div className="aspect-square w-full max-w-[640px] justify-self-center">
          <img
            src={kit.image}
            alt={description}
            width="1000"
            height="1000"
            className="w-full h-full object-contain"
            data-testid="team-match-kit-image"
          />
        </div>
      </div>
    </section>
  );
};